module.exports = __webpack_public_path__ + "6f5282410a38f08dcd84acbf60a89ab4.jpg";